import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'
import type { AccentVar } from './AccentContext'

export interface StatItem {
  k: ReactNode
  v: ReactNode
  unit?: ReactNode
  vSize?: number
  color?: AccentVar | string
  variant?: 'accent' | 'hot'
}

interface StatsProps {
  items: StatItem[]
  bordered?: boolean
  accentIndex?: number
  size?: 'mini'
  equalize?: boolean
  className?: string
  style?: CSSProperties
}

export function Stats({ items, bordered, accentIndex = -1, size, equalize = true, className, style }: StatsProps) {
  return (
    <div
      className={cx('st-stats', bordered && 'bordered', size, equalize && 'equalize', className)}
      style={{ ['--st-stats-cols' as string]: items.length, ...style }}>
      {items.map((s, i) => {
        const cls = cx('st-stat', s.variant, !s.color && !s.variant && i === accentIndex && 'accent')
        const style = s.color ? { background: `var(${s.color})` } : undefined
        return (
          <div key={i} className={cls} style={style}>
            <div className="k">{s.k}</div>
            <div className="v" style={s.vSize ? { fontSize: s.vSize } : undefined}>
              {s.v}
              {s.unit && <small>{s.unit}</small>}
            </div>
          </div>
        )
      })}
    </div>
  )
}
